import Formatter from 'formatter';
import template  from './upgrade-schedules.hbs';
import style     from 'upgrade-schedules.scss';
import Card      from './upgrade-card.es6';
import PayPal    from './upgrade-paypal.es6';
import Defines   from './upgrade-defines.es6';

export default Backbone.View.extend($.extend({}, Card, PayPal, {
    template,
    el: 'div.upgradeSchedules',
    initialize (options, upgrade) {
        this.upgrade = upgrade;
        this.formatter = new Formatter;
        this.setInitialState();
        this.model.on('plansChange', this.render, this);
        if (Card.initialize) {
            PayPal.initialize.apply(this, arguments);
        }
        if (PayPal.initialize) {
            PayPal.initialize.apply(this, arguments);
        }
    },
    events: _.extend({}, Card.events, PayPal.events, {
        'click tr.upgradeSchedules__item': 'onClick',
        'click .upgradeSchedules__cancel-button': 'onCancel',
        'submit form.upgradeSchedules__form': 'onSubmit',
        'buttonClick .upgradePayment__back-button': 'onBack',
        'buttonClick .upgradePayment__payment-button': 'onPayment',
    }),
    
    isVisible () {
        return this.$el.is(':visible');
    },
    show () {
        this.$el.show();
    },
    hide () {
        this.$el.hide();
    },
    toggle (condition) {
        this.$el.toggle(condition);
    },
    onClick (e) {
        e.preventDefault();
        let value = $(e.target).closest('tr').data('value');
        this.select(value);
    },
    onSubmit (e) {
        e.preventDefault();
        this.choose(this.state.selected);
    },
    onCancel (e) {
        this.upgrade.cancelUpgrade();
    },
    onBack (e) {
        e.preventDefault();
        this.clearState('chosen');
    },
    onPayment (e) {
        e.preventDefault();
        this.paymentHandlers[e.target.value].call(this);
    },
    paymentHandlers: $.extend({},
        Card.paymentHandlers,
        PayPal.paymentHandlers
    ),
    setInitialState () {
        let state = {};
        if (this.model.featureCheck('annual_payments')) {
            state.selected = Defines.SCHEDULE_ANNUAL_RECURRING;
        } else {
            state.selected = Defines.SCHEDULE_MONTHLY_RECURRING;
        }
        this.setState(state);
    },
    setUpgradedState (value) {
        this.extendState({upgraded: value});
    },
    setState (state) {
        this.state = state;
        this.render();
    },
    extendState (updates) {
        this.setState(_.extend({}, this.state, updates));
    },
    clearState (...keys) {
        keys.forEach((key) => {
            delete this.state[key];
        });
        this.render();
    },
    select (value) {
        this.extendState({selected: value});
    },
    choose (value) {
        this.extendState({chosen: value});
    },
    render () {
        if (!this.model.plans.solo) {
            return this;
        }
        this.$el.html(this.template(this.getTemplateData()));
        if (Card.render) {
            Card.render.call(this);
        }
        if (PayPal.render) {
            PayPal.render.call(this);
        }
        this.processEmoji();
        return this;
    },
    processEmoji () {
        emoji.include_title = false;
        this.$('.upgradeChecklist li').each(function (i, li) {
            let $li = $(li);
            $li.html(emoji.replace_unified($li.html()));
        });
        emoji.include_title = true;
    },
    getCountry () {
        return this.state.chosen_country || this.model.plans.country;
    },
    getTemplateData () {
        let data = {
            state: this.state,
            schedules: []
        };
        if (this.model.plans.eu_vat && this.model.plans.eu_vat.applicable) {
            data.vat_applicable = true;
        }
        if (!this.model.featureCheck('upgrades')) {
            data.disabled = true;
        }
        if (this.model.isDesktop()) {
            data.desktop = true;
        }
        if (this.model.isSSBFluid()) {
            data.ssb_fluid = true;
        }
        if (this.model.featureCheck('annual_payments')) {
            data.annual_payments = true;
        }
        let countries = _.map(this.model.plans.countries, (name, code) => {
            let isSelected = (code === this.getCountry());
            let country = {
                code,
                name,
                isSelected
            };
            if (isSelected) {
                data.detected_country = country;
            }
            return country;
        });
        data.countries = countries;
        if (this.state.paypal) {
            data['paypal_' + this.state.paypal] = true;
        }
        if (this.state.card) {
            data['card_' + this.state.card] = true;
        }
        if (this.model.featureCheck('upgrades')) {
            data.schedules = this.getAnnualPlans().concat(this.getMonthlyPlans());
        }
        
        if (data.schedules.length == 1) {
            data.only_schedule = true;
        }
        
        data.schedules.forEach((schedule) => {
            if (this.state.selected === schedule.value) {
                schedule.isActive = true;
            }
            if (data.only_schedule || this.state.chosen === schedule.value) {
                this.state.chosen = schedule.value;
                data.chosen_schedule = schedule;
                schedule.methods.forEach((method) => {
                    if (this.state.waiting === method.value) {
                        method.isWaiting = true;
                    }
                });
            }
        });
        return data;
    },
    isPayPalAvailable () {
        return !this.model.isSSBFluid();
    },
    getMonthlyPlans (state) {
        let monthlyPlans = [];
        if (!this.model.plans.solo) {
            return monthlyPlans;
        }
        let payment = [this.getPaymentCards()];
        let methods = [this.getPaymentCards()];
        if (this.isPayPalAvailable()) {
            if (this.model.plans.paypal_recurring_available) {
                payment.unshift(this.getPaymentPayPal());
                methods.push(this.getPaymentPayPal());
            }
        }
        let currency = this.model.getCurrency();
        let price = this.formatter.amount(
            '',
            this.model.plans.solo.amount,
            1,
            0
        );
        let period = 'per month; ' + this.formatter.amount(
            currency,
            this.model.plans.solo.amount * 12,
            1,
            0
        ) + ' a year';
        let monthlyRecurringPlan = {
            label: 'Monthly recurring',
            currencySymbol: this.formatter.getCurrencySymbol(currency),
            price,
            period,
            description: 'every month',
            payment,
            methods,
            value: Defines.SCHEDULE_MONTHLY_RECURRING
        };
        monthlyPlans.push(monthlyRecurringPlan);
        return monthlyPlans;
    },
    getAnnualPlans (state) {
        if (!this.model.featureCheck('annual_payments')) {
            return [];
        }
        let annualPlans = [];
        if (!this.model.plans.solo_yearly) {
            return annualPlans;
        }
        let payment = [this.getPaymentCards()];
        let methods = [this.getPaymentCards()];
        let oneOffPayment = [this.getPaymentCards()];
        let oneOffMethods = [this.getPaymentCards()];
        if (this.isPayPalAvailable()) {
            if (this.model.plans.paypal_recurring_available) {
                payment.unshift(this.getPaymentPayPal());
                methods.push(this.getPaymentPayPal());
            }
            oneOffPayment.unshift(this.getPaymentPayPal());
            oneOffMethods.push(this.getPaymentPayPal());
        }
        
        let currency = this.model.getCurrency();
        let currencySymbol = this.formatter.getCurrencySymbol(currency);
        let price = this.formatter.amount(
            '',
            this.model.plans.solo_yearly[currency].amount,
            1,
            0
        );
        
        let annualOneOffPlan = {
            label: 'Annual one-off',
            currencySymbol: currencySymbol,
            price,
            period: 'lasts for 1 year',
            description: 'for 12 months',
            payment: oneOffPayment,
            methods: oneOffMethods,
            value: Defines.SCHEDULE_ANNUAL_ONEOFF
        };
        annualPlans.push(annualOneOffPlan);
        
        let annualRecurringPlan = {
            label: 'Annual recurring',
            currencySymbol: currencySymbol,
            price,
            period: 'per year',
            description: 'every 12 months',
            payment,
            methods,
            value: Defines.SCHEDULE_ANNUAL_RECURRING
        };
        annualPlans.push(annualRecurringPlan);
        return annualPlans;
    },
}));



// WEBPACK FOOTER //
// ./app/src/view/upgrade-schedules.es6